const capitalize = (original: string) => {
  const [first, ...rest] = original.split("");

  return first.toUpperCase() + rest.join("");
};

const capitalizePerSpace = (string: string) =>{
  const words = string.split(' ');
  const capitalizedWords = words.map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1);
  });
  return capitalizedWords.join(' ');
}

export { capitalize, capitalizePerSpace };
